import { render, staticRenderFns } from "./MenusComponent.vue?vue&type=template&id=e0226a7c"
import script from "./MenusComponent.vue?vue&type=script&lang=js"
export * from "./MenusComponent.vue?vue&type=script&lang=js"
import style0 from "./MenusComponent.vue?vue&type=style&index=0&id=e0226a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports